import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Field, TextInput, SaveButton } from "./kit";
import SiteThemePanel from "./SiteThemePanel";

export default function SettingsPage() {
  const [s, setS] = useState(null);
  const [pw, setPw] = useState({ current_password: "", new_password: "" });

  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setS({ admin_email: data.admin_email, sender_email: data.sender_email, sendgrid_api_key: "" })).catch(() => {});
  }, []);

  if (!s) return null;

  const save = async () => {
    try {
      await api.put("/admin/settings", s);
      toast.success("Settings saved");
      setS({ ...s, sendgrid_api_key: "" });
    } catch (e) {
      toast.error("Save failed");
    }
  };

  const changePw = async () => {
    try {
      await api.post("/admin/settings/password", pw);
      toast.success("Password updated");
      setPw({ current_password: "", new_password: "" });
    } catch (e) {
      toast.error(e.response?.data?.detail || "Password change failed");
    }
  };

  return (
    <div className="space-y-6" data-testid="admin-settings">
      <SiteThemePanel />
      <Card title="Settings" desc="Admin account, sender identity and email provider.">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Admin email (booking notifications go here)">
            <TextInput value={s.admin_email || ""} onChange={(e) => setS({ ...s, admin_email: e.target.value })} />
          </Field>
          <Field label="Sender email (needs SendGrid verification)">
            <TextInput value={s.sender_email || ""} onChange={(e) => setS({ ...s, sender_email: e.target.value })} placeholder="e.g. hello@trustdesk.com" />
          </Field>
          <Field label="SendGrid API key" className="sm:col-span-2">
            <TextInput type="password" value={s.sendgrid_api_key || ""} onChange={(e) => setS({ ...s, sendgrid_api_key: e.target.value })} placeholder="SG.xxx — paste to replace the stored key" />
          </Field>
        </div>
        <p className="mt-3 text-xs text-slate-500">Until a SendGrid key is stored, emails are queued and shown as “pending” in the sent log.</p>
        <SaveButton onClick={save} saving={false} label="Save Settings" />
      </Card>

      <Card title="Change Password" desc="Update the admin login password.">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Current password"><TextInput type="password" value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} /></Field>
          <Field label="New password"><TextInput type="password" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} /></Field>
        </div>
        <button className="btn btn-sm btn-outline-light mt-6" onClick={changePw} data-testid="admin-change-password-button">Update Password</button>
      </Card>
    </div>
  );
}
